import React, { useCallback, useState } from "react";
import { AXIOS_DELETE, AXIOS_UPDATE } from "../../server/api/crud";
import UploadDocumenten from "../../Componenten/Calender/UploadDocumenten";
import Swal from "sweetalert2";
import { deleteObject, ref } from "firebase/storage";
import { storage } from "../../firebase/firebase";
import FileCardAdvies from "../../Componenten/MiniCards/FileCardAdvies";
import { useSelector } from "react-redux";
import RP_Avatar from "../../Componenten/RP_Avatar";
import SelectPatientSearch from "../../Componenten/SelectPatientSearch";
import { documentenKeuzen, sendEmailGewoon } from "../../function";
import { buildEmailData, emailDocumentenUpload } from "../../EmailTemplates";
import useInfinitePatientenDetails from "../../hooks/useInfinitePatientenDetails";

const getStoredPatientSearch = () => {
  if (typeof localStorage === "undefined") return "";
  return localStorage.getItem("QUERY") || "";
};

const classNames = (...classes) => {
  return classes.filter(Boolean).join(" ");
};

const PlansAdmin = ({
  userdetails,
  attachments,
  setRefresh,
  setAttachments,
  type = "uploads",
}) => {
  const [open, setOpen] = useState(false);
  const [select, setSelect] = useState([]);
  const [patientSearch, setPatientSearch] = useState(getStoredPatientSearch);
  const {
    error,
    hasMore,
    items: patientenselect,
    loading,
    sentinelRef,
  } = useInfinitePatientenDetails(patientSearch);
  const { patienten } = useSelector((state) => state.user);

  const handleChange = useCallback(
    async (p_id, e) => {
      if (!Array.isArray(select) || select.length === 0) return;

      const checks = e.target.checked;

      let title = checks
        ? `Wilt u deze patiënt rechten geven aan al deze ${select.length} bestanden?`
        : `Wilt u bij deze patiënt rechten afnemen voor al deze ${select.length} bestanden?`;

      const result = await Swal.fire({
        icon: "question",
        title: title,
        showCancelButton: true,
        confirmButtonText: "Ja",
        cancelButtonText: "Neen",
        confirmButtonColor: "#111827",
        cancelButtonColor: "green",
      });

      if (!result.isConfirmed) return;

      const batchSize = 3;

      const updateOneDocument = async (doc) => {
        const updatedUsers = checks
          ? [...(doc.users || []), p_id]
          : doc.users?.filter((user) => user !== p_id);

        const updatedDocument = { users: updatedUsers };

        console.log("Usersssss ==> ", doc);

        try {
          const resp = await AXIOS_UPDATE(
            `documents/admin`,
            doc.id,
            updatedDocument
          );

          if (resp.status === 200) {
            const klant = patientenselect?.find(
              (item) => item.user_id === p_id
            );

            // Update attachments state
            setAttachments((prev) =>
              prev.map((item) =>
                item.id === doc.id ? { ...item, users: updatedUsers } : item
              )
            );

            // Update select state
            if (checks) {
              setSelect((prev) =>
                prev.map((item) =>
                  item.id === doc.id ? { ...item, users: updatedUsers } : item
                )
              );
            } else {
              setSelect([]);
            }

            return {
              success: true,
              message: `Bestand: ${doc.bestand} is nu zichtbaar voor ${klant?.full_name}`,
            };
          } else {
            return {
              success: false,
              message: `Fout bij opslaan: ${doc.bestand}`,
            };
          }
        } catch (error) {
          console.error(`Error updating document ${doc.id}:`, error);
          return {
            success: false,
            message: `Fout bij het updaten van bestand: ${doc.bestand}`,
          };
        }
      };

      for (let i = 0; i < select.length; i += batchSize) {
        const batch = select.slice(i, i + batchSize);

        // Show progress before sending the batch
        /* Swal.fire({
          title: `Opslaan (${i + 1} - ${Math.min(i + batchSize, select.length)} van ${select.length})...`,
          didOpen: () => Swal.showLoading(),
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
        });*/

        const results = await Promise.all(batch.map(updateOneDocument));

        // Optional: Log or display batch results
        results.forEach((res) => {
          if (!res.success) console.warn(res.message);
        });
      }

      const recipient = patienten.find((el) => el?.user_id == p_id);

      const pagina = documentenKeuzen(1)['plans'];

      if (recipient) {
        const emailData = buildEmailData({
          from_name: "RepeatConnect",
          receiver: recipient.full_name,
          title: `Hallo ${recipient.full_name}, Er werden nieuwe documenten aan uw Mealplans/Voedingsmiddelentabel/Recepten`,
          receiver_email: recipient.email,
          object: pagina,
          name: userdetails?.full_name,
          bericht: "documenten",
        });

        const emailHtml = emailDocumentenUpload(emailData);

        sendEmailGewoon("template_qdoh9mv", {
        message_html: emailHtml,
        title: emailData.title,
        receiver_email: emailData.receiver_email,
      });
      }

      Swal.close();
      Swal.fire(
        "Klaar!",
        "Alle geselecteerde bestanden zijn bijgewerkt.",
        "success"
      );
      setSelect([]);

    },
    [select, patientenselect]
  );

  const deleteDocument = async (item) => {
    const result = await Swal.fire({
      title: "Bent u zeker deze document te willen verwijderen",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Ja",
      denyButtonText: "Neen",
      confirmButtonColor: "red",
      denyButtonColor: "gray",
    });

    const id = item.id;
    if (result.isConfirmed) {
      await AXIOS_DELETE("documents/admin", id)
        .then((result) => {
          if (result.status === 200) {
            // Create a reference to the file to delete
            const fileRef = ref(storage, item?.url);

            // Delete the file from Firebase Storage
            deleteObject(fileRef);
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: `Bestand is goed verwijderd`,
              showConfirmButton: false,
              timer: 2500,
            });

            setRefresh(true);
          }
        })
        .catch((e) => {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: `er is iets mis gelopen`,
            showConfirmButton: false,
            timer: 2500,
          });
        });
    }
  };

  function addItem(item) {
    setSelect((prev) => {
      // Check if any existing element has the same id
      const exists = prev.some((el) => el?.id === item?.id);
      if (exists) {
        return prev.filter((el) => el?.id != item?.id); // No change if already in the array
      }
      return [...prev, item];
    });
  }

  const checkedHasUSers = (patient) => {
    const count = select.filter((el) =>
      el?.users?.includes(patient?.user_id)
    ).length;
    return select.length == count && select?.length > 0;
  };

  return (
    <div className="mx-auto w-full bg-wa-app px-4 pt-6 sm:px-6 lg:px-8">
      <div className="mb-4 w-full overflow-x-auto">
        <SelectPatientSearch
          onSearchChange={setPatientSearch}
          search={patientSearch}
        />
      </div>
      {loading && patientenselect.length === 0 ? (
        <p className="pb-4 text-center text-sm text-wa-muted">Patiënten laden...</p>
      ) : null}
      {error ? (
        <p className="mb-4 rounded-lg border border-red-800/40 bg-red-950/30 px-3 py-2 text-sm text-red-200">
          {error}
        </p>
      ) : null}
      <div className="flex flex-col gap-4 lg:flex-row">
        <div className="w-full lg:w-8/12">
          <div className="rounded-lg border border-wa-border bg-wa-panel p-3">
            <button
              type="button"
              onClick={() => setOpen(true)}
              className="block rounded-md bg-wa-accent px-3 py-2 text-center text-sm font-semibold text-wa-onaccent shadow-sm transition hover:bg-wa-accentdeep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wa-accent"
            >
              Voeg een document toe
            </button>
            <div className="mt-4 grid grid-cols-1 gap-2 xl:grid-cols-2">
              {attachments?.length > 0 ? (
                attachments.map((item) => (
                  <div
                    key={item?.id || item?.url || item?.bestand}
                    onClick={() => addItem(item)}
                    className={classNames(
                      "rounded-lg transition",
                      select.some((el) => el?.id === item?.id)
                        ? "bg-wa-panel2 ring-2 ring-wa-accent"
                        : "bg-wa-panel2 ring-1 ring-wa-border hover:ring-wa-accent/60"
                    )}
                  >
                    <FileCardAdvies
                      item={item}
                      deleteDocument={deleteDocument}
                      userdetails={userdetails}
                    />
                  </div>
                ))
              ) : (
                <div className="col-span-full rounded-lg border border-wa-border bg-wa-panel2 p-8 text-center text-wa-muted">
                  <p>Er zijn geen documenten gevonden.</p>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="w-full lg:w-4/12">
          <div className="rounded-lg border border-wa-border bg-wa-panel p-3">
            <div className="mb-3 text-sm font-semibold text-wa-text">
              Patiënten toegang
            </div>
            <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            {patientenselect?.length > 0 &&
              patientenselect.map((patient) => (
                <div
                  key={patient?.user_id}
                  className="relative w-full cursor-pointer rounded-lg border border-wa-border bg-wa-panel2 p-2"
                  title={patient?.full_name}
                >
                  <div className="absolute left-2 top-2 rounded p-1">
                    <input
                      type="checkbox"
                      checked={checkedHasUSers(patient)}
                      onChange={(e) => handleChange(patient?.user_id, e)}
                      className="h-4 w-4 cursor-pointer rounded border-wa-border bg-wa-panel2 text-wa-accent focus:ring-wa-accent"
                    />
                  </div>
                  <div className="p-2 pt-4">
                    <RP_Avatar
                      avatar={patient?.avatar}
                      size={20}
                      alt={` ${patient?.full_name}`}
                    />
                    <span className="line-clamp-2 text-sm text-wa-text">
                      {patient?.full_name}
                    </span>
                  </div>
                </div>
              ))}
            </div>
            <div ref={sentinelRef} className="py-4 text-center text-sm text-wa-muted">
              {loading && patientenselect.length > 0
                ? "Meer patiënten laden..."
                : hasMore && patientenselect.length > 0
                  ? "Scroll verder voor meer patiënten."
                  : patientenselect.length > 0
                    ? "Alle patiënten geladen."
                    : null}
            </div>
          </div>
        </div>
      </div>
      <UploadDocumenten
        setRefresh={setRefresh}
        attachments={attachments}
        user={userdetails}
        type={type}
        open={open}
        setOpen={setOpen}
      />
    </div>
  );
};

export default PlansAdmin;
